// src/constants/constants.ts

const constants = {
  logo: "https://placehold.co/120x40?text=Logo",
  productImage1: "https://hyogiqxohlfioprwfbdy.supabase.co/storage/v1/object/public/images/dynamicimg1.png",
  productImage2: "https://hyogiqxohlfioprwfbdy.supabase.co/storage/v1/object/public/images/mattb4andafter.png",
  productImage3: "https://hyogiqxohlfioprwfbdy.supabase.co/storage/v1/object/public/images/productimg2.png",
  productImage4: "https://hyogiqxohlfioprwfbdy.supabase.co/storage/v1/object/public/images/productimg3.png",
  productImage5: "https://hyogiqxohlfioprwfbdy.supabase.co/storage/v1/object/public/images/dynamicimg2.png",
  backgroundImage: "https://hyogiqxohlfioprwfbdy.supabase.co/storage/v1/object/public/images/hairlossbackground.png",
  pdfDownload: "https://hyogiqxohlfioprwfbdy.supabase.co/storage/v1/object/public/images/7-day%20Personalized%20Plan.pdf",
  transparentOverlay: "https://hyogiqxohlfioprwfbdy.supabase.co/storage/v1/object/public/images/transp1.png"
};

export default constants;
